import { writable } from 'svelte/store';
import type { ZoneType } from '../../Zones/types';

export type ZoneListType = {
    ruleId: number;
    mapId: number;
    zoneList: ZoneType[];
};

export function createCurrentZoneListStore(onChange?: (v: ZoneListType[]) => void) {
    const currentZoneList = writable<ZoneListType[]>([]);

    if (onChange) {
        currentZoneList.subscribe(onChange);
    }

    function reset(v: ZoneListType[]) {
        currentZoneList.set(v);
    }

    function setZonesByRuleId(ruleId: number, mapId: number, zoneList: ZoneType[]) {
        currentZoneList.update(v => {
            let index = v.findIndex(zone => zone.ruleId === ruleId);
            if (index === -1) {
                v.push({ ruleId, mapId, zoneList });
            } else {
                v[index] = { ruleId, mapId, zoneList };
            }
            return v;
        });
    }

    return {
        ...currentZoneList,
        reset,
        setZonesByRuleId,
    };
}
